import { CaMeetingRequestContext, CaResult } from '../core';

import { Phase } from './model/phase.model';

export interface CaAnalysisDialogState {
    phase: Phase | null;

    minimized?: boolean;
    statuses: string[];
    transcriptStatus: 'grey' | 'green';

    /** @deprecated create and move to guide-picker state */
    meetingRequestContext?: CaMeetingRequestContext;

    result?: CaResult;
}

export const defaultState = (): CaAnalysisDialogState => ({
    phase: null,
    statuses: [],
    transcriptStatus: 'grey',
});
